export const PAST_DUE = "Past Due"
export const CURRENTLY_DUE = "Currently Due"
export const UPCOMING = "Upcoming"

export const CART_SIDE_PANEL_OPEN = "cartSidePanelOpen"
